import React from 'react'
import {
    Row,
    Col,
    Card,
    Table,
    Badge,
    Dropdown,
    ProgressBar,
    Button
} from "react-bootstrap";

const ViewUser = () => {
  return (
    <>
  
    <div className="row">
        <Col lg={12} className="mb-3">
            <Card style={{ height: '35vh' }}>
                <Card.Header>
                    <Card.Title className="text-danger">VERIFY DETAILS</Card.Title>
                </Card.Header>
                <Card.Body >
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Student Profile Photo</th>
                                <th>Action</th>
                                <th>Remarks</th>

                            </tr>

                        </thead>
                        <tbody>
                            <tr>
                                <th>1</th>
                                <th>Photo</th>
                               


                            </tr>

                        </tbody>
                    </Table>
                </Card.Body>
            </Card>


           

        </Col>

    </div>

   
</>
  )
}

export default ViewUser